import { useEffect, useState } from 'react';
import { Card, CardHeader } from '@mui/material';
import { collection, getCountFromServer, query, where } from 'firebase/firestore';
import { db } from '../../config/firebase';

const CardProductsStatus = ({ title, status }) => {
  const [stateCount, setStateCount] = useState(0);
  const productsCollectionRef = collection(db, 'products');
  const queryCollectionRef = query(productsCollectionRef, where('productStatus', '==', status));

  useEffect(() => {
    const countProducts = async () => {
      const productsSnapshot = await getCountFromServer(queryCollectionRef);
      setStateCount(productsSnapshot?.data().count);
    };
    countProducts().then();
  }, [productsCollectionRef]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card>
      <CardHeader
        title={title}
        subheader={stateCount}
        subheaderTypographyProps={{ variant: 'h4', color: 'primary' }}
      />
    </Card>
  );
};

export default CardProductsStatus;
